// extracted by mini-css-extract-plugin
export default {"blueBtn":"buttons_blueBtn__1jGgm","whiteBtn":"buttons_whiteBtn__5EBA0","defaultButton":"buttons_defaultButton__5RqdW"};